import { Component, inject, effect, TemplateRef, viewChild } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { MatDialogRef } from '@angular/material/dialog';
import { UiAlertHostComponent } from './shared/components/ui-alert-host.component';
import { TabTitleService } from './services/tabTitleService';
import { DRAWER_WIDTHS, DrawerService } from './services/drawer-service';
import { CarritoService } from './services/carrito-service';
import { CartDrawerComponent } from './shared/components/cart-drawer.component';
import { SlideBaseComponent } from './shared/components/slide-base-component/slide-base-component';

@Component({
  selector: 'app-root',
  imports: [
    RouterOutlet,
    UiAlertHostComponent,
    CartDrawerComponent
  ],
  templateUrl: './app.html',
  styleUrl: './app.scss'
})
export class App {
  private tabTitleService = inject(TabTitleService);
  private drawerService = inject(DrawerService);
  public carritoService = inject(CarritoService);

  drawerCarrito = viewChild.required<TemplateRef<unknown>>('drawerCarrito');

  // Guardamos la referencia del modal abierto
  private dialogRef: MatDialogRef<SlideBaseComponent> | null = null;

  constructor() {
    effect(() => {
      const estaAbierto = this.carritoService.isOpen();

      if (estaAbierto) {
        this.ejecutarAccionAlAbrir();
      } else {
        this.ejecutarAccionAlCerrar();
      }
    });
  }

  ngOnInit() {
    this.tabTitleService.initTabTitleListener();
  }

  private ejecutarAccionAlAbrir() {
    // Si ya existe uno abierto, no volvemos a abrir otro
    if (this.dialogRef) return;

    this.dialogRef = this.drawerService.open({
      title: 'Mi Carrito',
      content: this.drawerCarrito(),
      width: DRAWER_WIDTHS.SMALL,
      resizable: false,
    });

    // Si el usuario cierra el modal tocando el backdrop o mediante la X del drawer
    this.dialogRef.afterClosed().subscribe(() => {
      this.dialogRef = null;
      this.carritoService.reset();
    });
  }

  private ejecutarAccionAlCerrar() {
    if (this.dialogRef) {
      this.dialogRef.close();
      this.dialogRef = null;
    }
  }
}